export default __webpack_public_path__ + "static/media/contactus.21900262.svg";